import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class Configuration extends Resource {
    public override type = 'configurations';

    @prop()
    public code!: string;

    @prop()
    @required()
    public group!: string;

    @prop()
    @required()
    public name!: string;

    @prop()
    public description!: string;

    @prop()
    public value!: string;

    @prop()
    public dataType!: string;

    @prop()
    public controlType!: string;

    @prop()
    public visible: boolean = true;

    @prop()
    public system: boolean = false;

    @prop()
    public configuration!: string;
}
